module.exports = __webpack_public_path__ + "static/media/Finity.a8fba8e7.png";